import PropTypes from 'prop-types';
import styles from './error-box.module.less';

const ErrorBox = ({ error = '', children = null }) =>
    !(error || children) ? null : (
        <div className={styles.errorModalMessage} role="alert">
            {error || children}
        </div>
    );

ErrorBox.propTypes = {
    error: PropTypes.string,
    children: PropTypes.node,
};

export default ErrorBox;
